<template>
    <div style="display: flex; flex-direction: column; background-color: #15171D;">
        <div style="top: -126px; right: -140px;" class="blob_circle"></div>
        <div style="left: -205px; top: 330px;" class="blob_circle"></div>
        <div style="display: flex; align-items: center; margin-top: 14px; padding-left: 12px; position: relative; margin-bottom: 17px; z-index: 1;">
            <div @click="$GlobalStore.closeLastModal()">
                <img style="width: 10px;" :src="require('@/assets/img/gray_back.png')" alt="">
            </div>
            <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                <div style="text-align: center;">
                    <img style="width: 80px;" :src="require('@/assets/img/soccerhow_logo_text.png')" alt="">
                </div>
            </div>
        </div>
        <div style="flex: 1; overflow-y: scroll; color: #fff; padding: 0 12px; font-weight: 500; z-index: 1;">
            <div style="text-align: center; margin-top: 17px;">
                <div style="font-weight: 900; font-size: 28px; line-height: 36px;">소문 없이 은밀하게,<br>원하는 팀을 찾으세요.</div>
                <div style="margin-top: 5px; font-size: 14px; line-height: 24px;">이름, 소속팀, 얼굴은 숨기고<br>딱 필요한 정보로만 당당하게 제안해보세요</div>
            </div>
            <div style="display: flex; gap: 5px; align-items: center; margin-top: 36px;">
                <div style="background: linear-gradient(90deg, #D230FE 0%, #7179EC 100%); font-size: 12px; font-weight: 700; color: #fff; width: 46px; height: 24px; line-height: 24px; text-align: center; border-radius: 4px;">
                    BETA
                </div>  
                <div style="font-weight: 700; font-size: 12px; background: linear-gradient(90deg, #BC02FF 0%, #48C5FF 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; color: transparent;">시크릿 입단 요청서 베타 테스트 중입니다.</div>
            </div>
            <div style="margin-top: 15px;">
                <div class="card_wrapper" style="display: flex; align-items: center;">
                    <div style="width: 61px; flex-shrink: 0;">
                        <img style="width: 58px;" :src="require('@/assets/img/stat.png')" alt="">
                    </div>
                    <div>
                        <div class="card_title">최소 정보만 공개되는 입단 요청서</div>
                        <div class="card_desc">키, 체중, 주발, 포지션 등 선수를 식별할 수 없는 기존적인 신체 스텟만 노출해 감독님의 관심을 유도합니다.</div>
                    </div>
                </div>
                <div class="card_wrapper" style="display: flex; align-items: center; margin-top: 15px;">
                    <div style="width: 61px; flex-shrink: 0;">
                        <img style="width: 51px;" :src="require('@/assets/img/blind.png')" alt="">
                    </div>
                    <div>
                        <div class="card_title">기존 요청서도 모두 시크릿 변환</div>
                        <div class="card_desc">시크릿 모드를 활성화하는 즉시, 기존에 작성해 두었던 모든 입단 요청서와 게시물들이 일괄적으로 비공개(시크릿) 처리되어 안전하게 보호됩니다.</div>
                    </div>
                </div>
                <div class="card_wrapper" style="display: flex; align-items: center; margin-top: 15px;">
                    <div style="width: 61px; flex-shrink: 0;">
                        <img style="width: 61px;" :src="require('@/assets/img/secret_x.png')" alt="">
                    </div>
                    <div>
                        <div class="card_title">내 허락 없이는 볼 수 없어요.</div>
                        <div class="card_desc">감독님이 나의 입단 요청서를 열람하려면 반드시 열람 신청을 보내야 하며, 내가 수락 버튼을 누르기 전까지는 입단 요청서가 절대 공개 되지 않아요.</div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding: 0 24px; margin-bottom: 40px; color: #fff; font-weight: 500; margin-top: 10px;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <div style="display: flex; align-items: center; gap: 6px;">
                    <div>
                        <img v-if="isConfirmSecretAgreement" style="width: 18px;" :src="require('@/assets/img/secret_check.png')" alt="">
                        <img v-else style="width: 18px;" :src="require('@/assets/img/secret_un_check.png')" alt="">
                    </div>
                    <div style="font-size: 12px; line-height: 24px;">시크릿 입단 요청서 유의사항 확인<span style="color: #9E4CF6;">(필수)</span></div>
                </div>
                <div @click="showSecretAgreement" style="text-decoration: underline; font-size: 12px; line-height: 24px; font-size: 12px; line-height: 24px;">확인하기</div>
            </div>
            <!-- <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 21px;">
                <div style="font-size: 12px;">시크릿 입단 요청서 비용</div>
                <div style="font-weight: 900; font-size: 28px; line-height: 32px;">29,000<span style="font-size: 14px; font-weight: 700;">원</span></div>
            </div> -->
            <div @click="nextStep" :class="[isConfirmSecretAgreement ? 'active_button' : 'inactive_button']" style="margin-top: 5px; color: #fff; height: 48px; line-height: 48px; text-align: center; border-radius: 12px;">
                <span v-if="!isConfirmSecretAgreement" style="font-size: 14px; font-weight: 700;">시크릿 입단 요청서 작성하기</span>
                <span v-else style="font-size: 14px; font-weight: 700;">시크릿 입단 요청서 작성하기</span>
            </div>
        </div>
        <CommonPopupFrame :isOpen="isShowSecretAgreement" :closeCompleteAction="closeSecretAgreement" :maxHeight="maxHeight" :changeHeight="'auto'" :changeBottom="0">
            <div style="display: flex; flex-direction: column; flex: 1; overflow: hidden;">
                <div style="margin-bottom: 40px;" class="common_popup_header"></div>
                <div @touchmove.stop="() => {}" style="padding: 0 24px; font-weight: 700; flex: 1; overflow-y: scroll;">
                    <div style="font-size: 24px; font-weight: 900; line-height: 32px;">시크릿 입단 요청서란?</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #797979;">이적이나 진학을 준비하면서도 소문이 걱정되는 선수와 학부모님을 위해, 상세 정보를 보호하고 원하는 구단에 은밀하게 연락할 수 있는 입단 요청서예요.</div>
                    <div style="margin: 30px 0;">
                        <div v-for="each, i in secretFaqList" :key="i" :style="{ paddingTop: i === 0 ? '0' : '18px' }" style="padding-bottom: 18px; border-bottom: 1px solid #eee;">
                            <div @click="toggleSecretFaq(i)" style="display: flex; justify-content: space-between; align-items: center;">
                                <div :style="{ color: isSecretFaqOpen(i) ? 'var(--color-main)' : '' }" style="font-weight: 700; line-height: 24px;">{{ each.title }}</div>
                                <div style="margin-bottom: 4px;">
                                    <img v-if="!isSecretFaqOpen(i)" style="width: 8px;" :src="require('@/assets/img/arrow_small.png')" alt="">
                                    <img v-else style="width: 8px;" :src="require('@/assets/img/arrow_small_up.png')" alt="">
                                </div>
                            </div>
                            <div v-if="isSecretFaqOpen(i)" style="margin-top: 15px;">
                                <div v-html="each.desc" class="secret_desc"></div>
                                <div v-if="each.desc2" class="secret_desc" style="margin-top: 20px;">{{ each.desc2 }}</div>
                                <div v-if="each.desc3" class="secret_desc" style="margin-top: 20px;">{{ each.desc3 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding: 0 24px;">
                    <div @click="confirmSecretAgreement" style="height: 52px; border-radius: 12px; background-color: #000; color: #fff; font-weight: 500; font-size: 14px; line-height: 52px; text-align: center; margin-bottom: 30px;">확인했어요</div>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

export default {
    name: 'PaymentSecretRequestForm',
    components: { CommonPopupFrame },
    data() {
        return {
            isShowSecretAgreement: false,
            openFaqIndex: null,
            secretFaqList: [
                {
                    title: '내 시크릿 입단 요청서는 누구에게 보이나요?',
                    desc: '시크릿 입단 요청서를 작성하시면 이적시장에는 등록되지만, 회원님을 제외한 다른 사람에게는 상세 정보가 블라인드 처리됩니다',
                    desc2: '대신 포지션, 체격 조건, 희망 지역 등 기본적인 정보만 공개되어 감독님들이 확인하실 수 있습니다.',
                    desc3: '이후 감독님이 시크릿 입단 요청서 열람을 요청하고 회원님이 수락하거나, 회원님이 직접 감독님께 시크릿 입단 요청서를 보내고 감독님이 수락한 경우에만 상세 내용을 확인할 수 있습니다.'
                },
                {
                    title: '시크릿 요청서, 공개로 바꿀 수 있나요?',
                    desc: '네, 원하시면 마이페이지에서 언제든지 일반 공개 상태로 전환하실 수 있어요! 😊',
                    desc2: '다만, 공개로 전환하시는 것은 자율적인 선택이며, 작성하셨던 시크릿 입단 요청서들은 모두 공개가 됩니다.',
                    desc3: null
                },
                {
                    title: '원하지 않는 감독님이 열람하면 어떻게 되나요?',
                    desc: '모든 열람 권한은 회원님에게 있습니다. "수락"을 누르지 않으면 누구도 나의 상세 정보를 볼 수 없습니다.',
                    desc2: null,
                    desc3: null
                },
                {
                    title: '어떤 선수에게 추천하나요?',
                    desc: '출전 기회, 팀 환경, 진학 등 새로운 선택지를 고민하고 있지만, 주변의 시선이나 소문이 부담되어 조심스럽고 신중하게 움직이고 싶은 엘리트 선수에게 추천해요.',
                    desc2: '시크릿 입단 요청서는 JOINKFA 기준 엘리트 선수 인증이 가능한 회원만 이용할 수 있으며, 정확한 정보 작성을 바탕으로 안전하게 이용할 수 있어요. 허위 정보 작성 시 요청서 삭제 및 서비스 이용이 제한될 수 있습니다.',
                    desc3: null
                }

            ],
            maxHeight: 0,
            isConfirmSecretAgreement: false,
        }
    },
    created() {
        this.maxHeight = window.innerHeight
    },
    methods: {
        nextStep() {
            if (!this.isConfirmSecretAgreement) {
                this.showSecretAgreement()
                return
            }
            this.$GlobalStore.addModal('WriteSecretDefaultInfoForm')
        },
        confirmSecretAgreement() {
            this.isConfirmSecretAgreement = true
            this.isShowSecretAgreement = false
        },
        closeSecretAgreement() {
            this.isShowSecretAgreement = false
        },
        showSecretAgreement() {
            this.isShowSecretAgreement = true
        },
        toggleSecretFaq(index) {
            this.openFaqIndex = this.openFaqIndex === index ? null : index
        },
        isSecretFaqOpen(index) {
            return this.openFaqIndex === index
        }

    }
}
</script>

<style scoped>
.active_button {
    background: linear-gradient(90deg, #A855F7 0%, #B10486 100%);
}
.inactive_button {
    background-color: #2d3542;
}
.common_popup_header {
    width: 36px;
    height: 5px;
    background-color: #d9d9d9;
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 5px;
}

.card_wrapper {
    padding: 12px;
    gap: 10px;
    background: #FFFFFF1A;
    border-top-left-radius: 24px;
    border-bottom-right-radius: 24px;
    border: 2px solid #FFFFFF1A;
    padding-right: 9px;
}

.card_title {
    font-weight: 700;
    line-height: 24px;
}

.card_desc {
    font-size: 12px;
    line-height: 24px;
    font-weight: 400;
}

.blob_circle {
position: fixed;
    width: 366px;
    height: 366px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 35%,
            rgba(158, 76, 246, 0.85) 0%,
            rgba(158, 76, 246, 0.45) 20%,
            rgba(158, 76, 246, 0.00) 70%);
    filter: blur(40px);
    opacity: 0.9;
    pointer-events: none;
    z-index: 0;
    
}

.secret_desc {
    line-height: 20px;
    font-size: 12px;
    font-weight: 500;
}
</style>